import { render, staticRenderFns } from "./clientsList.vue?vue&type=template&id=a57d52cc&scoped=true&"
import script from "./clientsList.vue?vue&type=script&lang=js&"
export * from "./clientsList.vue?vue&type=script&lang=js&"
import style0 from "./clientsList.vue?vue&type=style&index=0&id=a57d52cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57d52cc",
  null
  
)

export default component.exports